import { License, MarketMoverEmailNotifications, UserPreferences, UserState } from '@/stores/User/state'

export const SET_USER = 'SET - User identity'
export const UPDATE_USER_IS_FIRST_SIGNIN = 'SET - User first signin'
export const WIPE_USER = 'SET - Wipe user identity'
export const UPDATE_USER_CLIENT = 'SET - Update user client display name'
export const SET_PROVISIONAL_USER_PREFERENCES = 'SET - Provisional user preferences'
export const SET_USER_PREFERENCES = 'SET - User preferences'
export const SET_SELECTED_UNIVERSES = 'SET - Selected worlds'
export const SET_UNIVERSES = 'SET - Universes'
export const TOGGLE_UNIVERSES = 'SET - Toggle universe status'
export const SET_USER_SURVEY = 'SET - User survey data'
export const SET_MARKET_MOVER_EMAIL_NOTIFICATIONS = 'SET - Market mover email notifications'
export const SET_MARKET_MOVER_EMAIL_NOTIFICATIONS_DIRTY = 'SET - Market mover email notifications dirty state'

export default {
  [SET_USER](state: UserState, user) {
    state.user = user
  },
  [UPDATE_USER_IS_FIRST_SIGNIN](state: UserState, isFirstSignIn) {
    state.user = Object.assign({}, state.user, { isFirstSignIn: isFirstSignIn })
  },
  [UPDATE_USER_CLIENT](state: UserState, client) {
    state.user = Object.assign({}, state.user, { client: Object.assign({}, state.user.client, client) })
  },
  [WIPE_USER](state) {
    state.user = null
  },
  [SET_UNIVERSES](state: UserState, payload) {
    state.licenseList = payload
  },
  [TOGGLE_UNIVERSES](state: UserState, payload: License) {
    const foundItemIndex: number = state.selectedUniverses?.findIndex((item) => item.id === payload.id) as number
    if (foundItemIndex < 0 && state.selectedUniverses) {
      state.selectedUniverses.push(payload)
    } else if (state.selectedUniverses) {
      state.selectedUniverses.splice(foundItemIndex, 1)
    }
  },
  [SET_SELECTED_UNIVERSES](state: UserState, universes) {
    if (!universes) {
      return
    }

    if (!state.selectedUniverses || !universes.length) {
      state.selectedUniverses = universes
      return
    }

    universes.forEach((universe) => {
      const foundItemIndex = state.selectedUniverses?.findIndex((item) => item.name === universe.name) as number
      if (foundItemIndex < 0) {
        state.selectedUniverses!.push(universe)
      }
    })
  },
  [SET_USER_PREFERENCES](state: UserState, payload: Partial<UserPreferences>) {
    state.preferences = { ...state.preferences, ...payload } as UserPreferences
  },
  [SET_PROVISIONAL_USER_PREFERENCES](state: UserState, payload: Partial<UserPreferences>) {
    state.provisionalPreferences = { ...state.provisionalPreferences, ...payload } as Partial<UserPreferences>
  },
  [SET_USER_SURVEY](state: UserState, payload) {
    state.survey = payload
  },
  [SET_MARKET_MOVER_EMAIL_NOTIFICATIONS](state: UserState, payload: MarketMoverEmailNotifications) {
    state.marketMoverEmailNotifications = payload
  },
  [SET_MARKET_MOVER_EMAIL_NOTIFICATIONS_DIRTY](state: UserState, payload: boolean) {
    state.marketMoverEmailNotificationsDirty = payload
  },
}
